// ROUTE FRONTEND
/***** ****** ****** ****** ****** ******
 *            ROUTE ALL
 ***** ****** ****** ****** ****** ******/
export const ROUTE_LOGIN = "/login";
export const ROUTE_PROFILE = "/profile"; //???
export const ROUTE_STAMPING = "/stamping";
export const ROUTE_NOT_AUTH = "/no-auth";
export const ROUTE_NOT_FOUND = "/404";
export const ROUTE_DUPLICATED_TAB = "/duplicated-tab";
export const ROUTE_NO_STORAGE = "/no-storage";
export const ROUTE_NO_GEOLOCATION = "/no-geolocation";
export const ROUTE_DEVICE_ERROR = "/device-error";
/***** ****** ****** ****** ****** ******
 *            ROUTE ADMIN
 ***** ****** ****** ****** ****** ******/
export const ROUTE_DASHBOARD = "/";
export const ROUTE_USERS = "/users";
export const ROUTE_TEAMS = "/teams";
export const ROUTE_CLIENTS = "/clients";
export const ROUTE_ASSISTANCES = "/assistances";
export const ROUTE_ASSISTANCES_SHOW = "/assistances/:idParams/:paramsAction";
export const ROUTE_SEARCH = "/search";
export const ROUTE_SEARCH_COMMAND = "/search/:paramType/:paramAction";
export const ROUTE_LOG = "/log";
export const ROUTE_LOG_ANALYTICS = "/log-analytics";
export const ROUTE_ABOUT = "/about";
/***** ****** ****** ****** ****** ******
 *            ROUTE VIEWER
 ***** ****** ****** ****** ****** ******/
//CRUD ACTION
export const INSERISCI = "insert";
export const AGGIORNA = "edit";
export const RIMUOVI = "delete";
export const VEDI = "show";
export const STR_LOGOUT_ERROR = "Logout non possibile...";
export const MAX_MATERIALS_NUMBER = 30;
export const FROM_ERROR_HTTP_CODE = 300;
